export enum BreadcrumbLabel {
    MyLoans = 'My Loans',
    Passbook = 'Passbook',
    Documents = 'Documents'
}

export interface HasBreadcrumb {
    breadcrumb(): Promise<BreadcrumbLabel | string>;
}